import axios from 'axios'
import { Nullable } from '@/shared/types/app.types'
import {
    AssaysViewApplyAssaysRequest, AssaysViewSubportionResponse,
    AssaysViewSubportionsCancelRequest, HierarchicalSubportionTreeRequest
} from '@/components/assays-view/services/assays-view-subportion/assays-view-subportion.dto'

class AssaysViewSubportionService {
    async cancelSubportions(
        laboratoryId: number,
        caseId: number,
        subportionsCancelRequests: AssaysViewSubportionsCancelRequest[]
    ): Promise<void> {
        const response =
            await axios.put<void>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/subportions/cancelBatch`,
                subportionsCancelRequests)
        return response.data
    }

    async createSubportions(
        laboratoryId: number,
        caseId: number,
        copies: number,
        assaysViewApplyAssaysRequest: AssaysViewApplyAssaysRequest
    ): Promise<AssaysViewSubportionResponse[]> {
        const response =
            await axios.post<AssaysViewSubportionResponse[]>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/subportions/createBatch`,
                assaysViewApplyAssaysRequest,
                {
                    params: { copies }
                })
        return response.data
    }

    async deleteSubportions(
        laboratoryId: number,
        caseId: number,
        hierarchicalSubportionTreeRequests: HierarchicalSubportionTreeRequest[]
    ): Promise<void> {
        const response =
            await axios.delete<void>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/subportions/deleteBatch`,
                { data: hierarchicalSubportionTreeRequests })
        return response.data
    }

    async discardSubportions(
        laboratoryId: number,
        caseId: number,
        hierarchicalSubportionTreeRequests: HierarchicalSubportionTreeRequest[]
    ): Promise<void> {
        const response =
            await axios.put<void>(
                `assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/subportions/discardBatch`,
                hierarchicalSubportionTreeRequests)
        return response.data
    }

    async undoDiscardSubportions(
        laboratoryId: number,
        caseId: number,
        hierarchicalSubportionTreeRequests: HierarchicalSubportionTreeRequest[]
    ): Promise<void> {
        const response =
            await axios.put<void>(
                `assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/subportions/undoDiscardBatch`,
                hierarchicalSubportionTreeRequests)
        return response.data
    }

    async updateSubportions(
        laboratoryId: number,
        caseId: number,
        hierarchicalSubportionTreeRequest: HierarchicalSubportionTreeRequest[],
        assayId: Nullable<number>,
        priorityId: Nullable<number>,
        assayDeviceId: Nullable<number>
    ): Promise<AssaysViewSubportionResponse[]> {
        const response =
            await axios.put<AssaysViewSubportionResponse[]>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/subportions/updateBatch`,
                hierarchicalSubportionTreeRequest,
                {
                    params: {
                        assayId,
                        priorityId,
                        assayDeviceId
                    }
                })
        return response.data
    }
}

export const assaysViewSubportionService = new AssaysViewSubportionService()
